import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=5ca3c238&"
import script from "./TopMenu.vue?vue&type=script&lang=js&"
export * from "./TopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca3c238')) {
      api.createRecord('5ca3c238', component.options)
    } else {
      api.reload('5ca3c238', component.options)
    }
    module.hot.accept("./TopMenu.vue?vue&type=template&id=5ca3c238&", function () {
      api.rerender('5ca3c238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/TopMenu.vue"
export default component.exports